import get from 'lodash.get';

import * as Actions from './seller.actions';
import { emptyArray } from 'ui-components/default-props/empty';
import { presetService } from '../../services/preset-service';
import { storeRefreshService } from '../../services/store-refresh-service';
import * as CarrierSharingActions from '../../store/carrier-sharing/carrier-sharing.actions';
import * as CswActions from '../../store/csw/csw.actions';
import * as PresetActions from '../../store/seller/presets/seller.presets.actions';
import { APP_INITIALIZATION } from '../core/base-actions';
import { EXTERNAL_SHIP_FROM_PREFIX } from '../csw/csw.fulfillment-plan-to-csw';
import { SET_EXISTING_DEMO_ORDER } from '../demos/demos.actions';
import { ADD_NEW_TAG_SUCCESS, EDIT_TAG_SUCCESS, DELETE_TAG_SUCCESS, GET_SELLER_TAGS_SUCCESS } from '../tags/tags.actions';
import { UPDATE_USERS_LIST } from '../user/user.actions';

const initialState = {
  presetHotkeys: [],
  loadingStoreIds: [],
  isLoading: false,
  presets: null,
  totesData: {
    totes: [],
    isLoading: false,
    error: null,
  },
};

const handleClearOutServiceMappings = (state) => {
  const { stores } = state.data;

  return {
    ...state,
    data: {
      ...state.data,
      stores: stores.map((store) => ({ ...store, serviceMappings: undefined })),
    },
  };
};

const handleGetServiceMappingsSuccess = (state, action) => {
  const { data } = action;
  const { stores } = state.data;

  Object.keys(data).forEach((storeGuid) => {
    const store = stores.find((s) => s.storeGuid === storeGuid);
    if (!store) {
      return;
    }
    store.serviceMappings = data[storeGuid];
  });
  return {
    ...state,
    data: {
      ...state.data,
      stores,
    },
  };
};

const handleTagChange = (state, action) => {
  switch (action.type) {
    case ADD_NEW_TAG_SUCCESS:
      return {
        ...state,
        data: {
          ...state.data,
          tags: [...state.data.tags, ...action.tags],
        },
      };
    case EDIT_TAG_SUCCESS: {
      const { tag } = action;
      const currentTags = state.data.tags;
      return {
        ...state,
        data: {
          ...state.data,
          tags: currentTags.map((currentTag) => {
            if (currentTag.tagId === tag.tagId) {
              return tag;
            }
            return currentTag;
          }),
        },
      };
    }
    case DELETE_TAG_SUCCESS: {
      const { tagId } = action;
      const currentTags = state.data.tags;
      return {
        ...state,
        data: {
          ...state.data,
          tags: currentTags.filter((tag) => tag.tagId !== tagId),
        },
      };
    }
    case GET_SELLER_TAGS_SUCCESS: {
      return {
        ...state,
        data: {
          ...state.data,
          tags: action.tags,
        },
      };
    }
    default:
      return state;
  }
};

export const reduce = (state = initialState, action) => {
  const { seller, data, storeGuid, initialData } = action;

  const allStores = get(state, 'data.stores', emptyArray).filter((store) => store.marketplaceId !== 0 && store.isActive);
  switch (action.type) {
    case Actions.GET_SELLER_LIGHT_SUCCESS:
    case Actions.GET_SELLER_SUCCESS:
      return {
        ...state,
        ...seller,
      };
    case APP_INITIALIZATION:
      return {
        ...state,
        ...initialData.seller,
        data: {
          ...state.data,
          fulfillmentProviders: initialData.fulfillmentProviders.map((provider) => {
            return {
              ...provider,
              shipFromId: `${EXTERNAL_SHIP_FROM_PREFIX}${provider.sellerFulfillmentProviderId}`,
            };
          }),
          presetHotkeys: initialData.presets,
          isLoading: false,
          partnerSharedServices: initialData.sharedServices,
          tags: initialData.tags,
          labelProviders: initialData.labelProviders,
          planInfo: initialData.planInfo,
          shipFroms: initialData.shipFroms,
          stores: initialData.stores,
          packages: initialData.packages,
          services: initialData.services,
          extendedServices: initialData.extendedServices,
          deliveryTemplates: initialData.deliveryTemplates,
          shipmentTemplates: initialData.shipmentTemplates,
          packingSlips: initialData.packingSlips,
          packageSets: initialData.packageSets,
          returnReasons: initialData.returnReasons,
          settings: initialData.settings,
          fulfillmentServices: initialData.fulfillmentServices,
          inventoryWarehouses: initialData.inventoryWarehouses,
          inventoryWarehousesLocations: initialData.inventoryWarehousesLocations,
          totes: [],
          totesIsLoading: false,
          totesError: null,
          wallets: initialData.wallets,
          sellerBrands: initialData.sellerBrands,
          pendingFulfillmentPartners: initialData.pendingFulfillmentPartners,
          shipperHQConnectedStores: initialData.shipperHQConnectedStores,
          serviceCollections: initialData.serviceCollections,
          subscriptionData: initialData.subscriptionData,
          countryConfig: initialData.countryConfig,
          presets: initialData.presets,
          userSettings: initialData.userSettings,
          fulfillmentProviderOptions: initialData.fulfillmentProviderOptions,
          demoFulfillmentPlanId: initialData.demoFulfillmentPlanId,
          fulfillmentProviderWarehouses: initialData.fulfillmentProviderWarehouses,
        },
      };
    case Actions.GET_SELLER_DATA_SUCCESS: {
      const fulfillmentProviders = data?.fulfillmentProviders ?? emptyArray;
      return {
        ...state,
        data: {
          ...data,
          fulfillmentProviders: fulfillmentProviders.map((provider) => {
            return {
              ...provider,
              shipFromId: `${EXTERNAL_SHIP_FROM_PREFIX}${provider.sellerFulfillmentProviderId}`,
            };
          }),
        },
      };
    }
    case Actions.UPDATE_STORE_AFTER_REFRESH:
      return storeRefreshService.updateStoreStatus(action.data, state);
    case PresetActions.CREATE_OR_UPDATE_PRESET_REQUEST:
    case PresetActions.GET_PRESETS_REQUEST:
    case PresetActions.DELETE_PRESET_REQUEST:
      return {
        ...state,
        data: {
          ...state.data,
          isLoading: true,
        },
      };

    case PresetActions.CREATE_OR_UPDATE_PRESET_SUCCESS: {
      const presetsInState = get(state, 'data.presets', emptyArray);
      const presets = presetService.removePresetById(presetsInState, action.preset.presetId);
      const newPresets = [...presets, action.preset];
      return {
        ...state,
        data: {
          ...state.data,
          presets: newPresets.sort((a, b) => a.sortOrder - b.sortOrder),
        },
      };
    }

    case PresetActions.CREATE_OR_UPDATE_PRESET_FAILURE: {
      return {
        ...state,
        data: {
          ...state.data,
          isLoading: false,
        },
      };
    }

    case PresetActions.DELETE_PRESET_SUCCESS: {
      const presetsInState = get(state, 'data.presets', emptyArray);
      const presets = presetService.removePresetById(presetsInState, action.presetId);
      return {
        ...state,
        data: {
          ...state.data,
          presets,
          isLoading: false,
        },
      };
    }

    case PresetActions.UPDATE_PRESET_HOTKEYS_SUCCESS: {
      return {
        ...state,
        data: {
          ...state.data,
          presetHotkeys: action.payload.presetHotkeys,
          isLoading: false,
        },
      };
    }

    case CswActions.CSW_SAVE_PACKAGE_SET_SUCCESS:
      return {
        ...state,
        data: {
          ...state.data,
          packageSets: [...state.data.packageSets, action.packageSet],
        },
      };
    case CswActions.CSW_DELETE_PACKAGE_SET_SUCCESS: {
      const { packageSetId } = action;
      return {
        ...state,
        data: {
          ...state.data,
          packageSets: state.data.packageSets.filter((packageSet) => packageSet.packageSetId !== packageSetId),
        },
      };
    }
    case Actions.GET_SERVICE_MAPPINGS_SUCCESS:
      return handleGetServiceMappingsSuccess(state, action);
    case Actions.REFRESH_STORE_REQUEST:
      return {
        ...state,
        loadingStoreIds: [storeGuid],
        isLoading: true,
      };
    case Actions.REFRESH_ALL_STORES_REQUEST:
      return {
        ...state,
        loadingStoreIds: allStores.map((store) => store.storeGuid),
        isLoading: true,
      };
    case Actions.REFRESH_SELECTED_ORDERS_REQUEST: {
      const storeGuids = action.storeGuids ?? emptyArray;
      return {
        ...state,
        loadingStoreIds: [...new Set([...state.loadingStoreIds, ...storeGuids])],
        isLoading: true,
      };
    }
    case Actions.REFRESH_SELECTED_ORDERS_SUCCESS:
    case Actions.REFRESH_SELECTED_ORDERS_ERROR: {
      const storeGuids = action.storeGuids ?? emptyArray;
      const remainingLoadingStoreIds = storeGuids.length ? state.loadingStoreIds.filter((id) => !storeGuids.includes(id)) : emptyArray;

      return {
        ...state,
        loadingStoreIds: remainingLoadingStoreIds,
        isLoading: remainingLoadingStoreIds.length > 0,
      };
    }
    case Actions.REFRESH_STORE_SUCCESS:
      return {
        ...state,
        isLoading: false,
      };
    case Actions.REFRESH_ALL_STORES_SUCCESS:
      return {
        ...state,
        isLoading: false,
      };
    case Actions.NEW_ORDERS_IMPORTED_FROM_REFRESH:
      return {
        ...state,
        isLoading: false,
      };
    case SET_EXISTING_DEMO_ORDER:
      return {
        ...state,
        data: {
          ...state.data,
          demoFulfillmentPlanId: action.data,
        },
      };

    case Actions.ADD_SHIP_FROM: {
      const shipFroms = [...state.data.shipFroms, action.shipFrom];
      return {
        ...state,
        data: {
          ...state.data,
          shipFroms,
        },
      };
    }
    case Actions.EDIT_SHIP_FROM: {
      const shipFroms = state.data.shipFroms.map((shipfrom) => {
        if (shipfrom.shipFromId === action.shipFrom.shipFromId) {
          return action.shipFrom;
        }
        return shipfrom;
      });
      return {
        ...state,
        data: {
          ...state.data,
          shipFroms,
        },
      };
    }
    case Actions.DELETE_SHIP_FROM: {
      const shipFromArray = [...state.data.shipFroms];
      const shipFroms = shipFromArray.filter((shipFrom) => shipFrom.shipFromId !== action.shipFromId);
      return {
        ...state,
        data: {
          ...state.data,
          shipFroms,
        },
      };
    }
    case Actions.UPDATE_SELLER_SHIP_FROMS: {
      return {
        ...state,
        data: {
          ...state.data,
          shipFroms: action.shipFroms,
        },
      };
    }
    case Actions.REFRESH_LABEL_PROVDIERS_SUCCESS:
      return {
        ...state,
        data: {
          ...state.data,
          labelProviders: action.labelProviders,
        },
      };
    case Actions.REFRESH_SHIPPING_SERVICES_SUCCESS:
      return {
        ...state,
        data: {
          ...state.data,
          services: action.services,
        },
      };
    case Actions.REFRESH_SERVICE_COLLECTIONS_SUCCESS:
      return {
        ...state,
        data: {
          ...state.data,
          serviceCollections: action.serviceCollections,
        },
      };
    case Actions.REFRESH_PACKAGES_SUCCESS:
      return {
        ...state,
        data: {
          ...state.data,
          packages: action.packages,
        },
      };
    case Actions.REFRESH_LABEL_PROVIDERS_FAILURE:
    case Actions.ACCEPT_DHL_WALLET_TERMS_REQUEST:
      return {
        ...state,
        dhlWalletAcceptTerms: true,
      };
    case Actions.ACCEPT_DHL_WALLET_TERMS_FAILURE:
      return {
        ...state,
        dhlWalletAcceptTerms: false,
      };
    case ADD_NEW_TAG_SUCCESS:
    case EDIT_TAG_SUCCESS:
    case GET_SELLER_TAGS_SUCCESS:
    case DELETE_TAG_SUCCESS: {
      return handleTagChange(state, action);
    }
    case Actions.GET_STORE_ERROR_LOG:
      return {
        ...state,
        data: {
          ...state.data,
          storeErrorLogs: {
            isLoading: true,
            storeGuid: action.storeId,
          },
        },
      };
    case Actions.GET_STORE_ERROR_LOG_SUCCESS:
      return {
        ...state,
        data: {
          ...state.data,
          storeErrorLogs: {
            isLoading: false,
            storeGuid: action.storeId,
            errors: action.data,
          },
        },
      };
    case Actions.GET_STORE_ERROR_LOG_FAILURE:
      return {
        ...state,
        data: {
          ...state.data,
          storeErrorLogs: {
            isLoading: false,
          },
        },
      };
    case Actions.CLEAR_OUT_SERVICE_MAPPINGS:
      return handleClearOutServiceMappings(state);
    case Actions.SAVE_NEW_SELLER_SETTINGS:
      return {
        ...state,
        data: {
          ...state.data,
          settings: {
            ...state.data.settings,
            ...action.newSellerSettings,
          },
        },
      };
    case Actions.UPDATE_SELLER_TIMEZONE:
      return {
        ...state,
        timeZoneIana: action.timeZone.timeZoneIana,
        timeZoneOffset: action.timeZone.utcOffset,
      };
    case Actions.UPDATE_SELLER_PHONE:
      return {
        ...state,
        phone: action.phone,
      };
    case UPDATE_USERS_LIST:
      return {
        ...state,
        users: action.users,
      };
    case Actions.UPDATE_SHIPSURANCE_BALANCE: {
      return {
        ...state,
        shipsuranceAccountInfo: {
          ...state.shipsuranceAccountInfo,
          balance: {
            ...state.shipsuranceAccountInfo.balance,
            value: action.value,
          },
        },
      };
    }
    case Actions.UPDATE_SELLER_WALLETS: {
      return {
        ...state,
        data: {
          ...state.data,
          wallets: action.wallets,
        },
      };
    }
    case CarrierSharingActions.GET_PARTNER_SHARED_SERVICES_SUCCESS: {
      return {
        ...state,
        data: {
          ...state.data,
          partnerSharedServices: action.services,
        },
      };
    }
    case Actions.REFRESH_STORE_LIST_SUCCESS: {
      return {
        ...state,
        data: {
          ...state.data,
          ...data,
        },
      };
    }
    case Actions.UPDATE_SELLER_INVENTORY_WAREHOUSES: {
      return {
        ...state,
        data: {
          ...state.data,
          inventoryWarehouses: action.inventoryWarehouses,
        },
      };
    }
    case Actions.REFRESH_PACKING_SLIP_TEMPLATES_SUCCESS: {
      return {
        ...state,
        data: {
          ...state.data,
          packingSlips: action.data,
        },
      };
    }
    case Actions.REFRESH_SHIPMENT_EMAIL_TEMPLATES_SUCCESS:
      return {
        ...state,
        data: {
          ...state.data,
          shipmentTemplates: action.data,
        },
      };
    case Actions.REFRESH_DELIVERY_EMAIL_TEMPLATES_SUCCESS: {
      return {
        ...state,
        data: {
          ...state.data,
          deliveryTemplates: action.data,
        },
      };
    }
    case Actions.UPDATE_SELLER_INVENTORY_WAREHOUSES_LOCATIONS: {
      return {
        ...state,
        data: {
          ...state.data,
          inventoryWarehousesLocations: action.inventoryWarehousesLocations,
        },
      };
    }
    case Actions.GET_SELLER_TOTES_REQUEST: {
      return {
        ...state,
        totesData: {
          ...state.totesData,
          isLoading: true,
        },
      };
    }
    case Actions.UPDATE_SELLER_TOTES: {
      return {
        ...state,
        totesData: {
          totes: action.totes,
          isLoading: false,
          error: null,
        },
      };
    }
    case Actions.SET_SELLER_TOTES_ERROR: {
      return {
        ...state,
        totesData: {
          ...state.totesData,
          isLoading: false,
          error: action.error,
        },
      };
    }
    case Actions.UPDATE_SHIPPERHQ_CONNECTED_STORES: {
      return {
        ...state,
        data: {
          ...state.data,
          shipperHQConnectedStores: action.storeGuids,
        },
      };
    }
    case Actions.REFRESH_SELLER_DATA_BY_PROPERTY_NAME: {
      return {
        ...state,
        data: {
          ...state.data,
          [action.propertyName]: action.data,
        },
      };
    }
    case Actions.UPDATE_SELLER_PLAN_INFO: {
      return {
        ...state,
        data: {
          ...state.data,
          planInfo: action.planInfo,
        },
      };
    }
    case Actions.UPDATE_SELLER_SUBSCRIPTION_DATA: {
      return {
        ...state,
        data: {
          ...state.data,
          subscriptionData: action.subscriptionData,
        },
      };
    }
    case Actions.UPDATE_HAS_CREATED_LABEL: {
      // hack: this is simply for testing and can be removed at any time
      return {
        ...state,
        hasCreatedLabel: action.hasCreatedLabel,
      };
    }
    case Actions.UPDATE_BUY_NOW_SETTING: {
      return {
        ...state,
        data: {
          ...state.data,
          settings: {
            ...state.data.settings,
            IsBuyNow: action.setting,
          },
        },
      };
    }
    default:
      return state;
  }
};
